const htmlTagRegex = /<\/?[a-z][^>]*>/i;

const detectHtml = (result: string) => htmlTagRegex.test(result);

export default detectHtml;
